<template>

    <div
        class="nav-item nav-item-dropdown"
        v-tooltip="{ content: label, placement: 'right', container: false, disabled: !collapsed }"
    >
        <v-dropdown
            :items="items"
            :show-selected="false"
            fixed
            :menu-position="resolvedMenuPosition"
            @change="$emit('change', $event)"
        >
            <template #toggle="{ toggle, show }">
                <a
                    class="nav-link"
                    :class="{ active: show }"
                    href="#"
                    :aria-label="label"
                    :aria-expanded="show ? 'true' : 'false'"
                    aria-haspopup="menu"
                    @click.prevent="toggle"
                >
                    <span>
                        <i class="icon" :class="icon" aria-hidden="true" />
                        <span class="label">{{ label }}</span>
                    </span>
                    <span v-if="!collapsed || $slots.append" class="nav-link-aside">
                        <slot name="append" />
                        <i v-if="!collapsed" class="fas fa-caret-down text-muted" aria-hidden="true" />
                    </span>
                </a>
            </template>
        </v-dropdown>
    </div>

</template>

<style scoped lang="scss">

    .nav-item-dropdown {
        overflow: visible;
        width: 100%;
        .dropdown {
            width: 100%;
        }
        .nav-link-aside {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            gap: 5px;
        }
    }

</style>

<script>

import Dropdown from '@cmp/Dropdown';

export default {

    components: {
        'v-dropdown': Dropdown,
    },

    props: {
        icon: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        menuPosition: {
            type: String,
            default: null,
        },
    },

    computed: {

        collapsed() {
            return this.$store.getters.sidebarState === 'collapsed';
        },

        resolvedMenuPosition() {
            if (this.menuPosition) {
                return this.menuPosition;
            }
            return this.collapsed ? 'right' : 'tl';
        },

    },

}

</script>
